import type { PropsWithChildren } from 'react'

import { DescriptionItem } from './components/DescriptionItem/DescriptionItem'
import { DescriptionsStyled } from './styles/DescriptionsStyled'

export interface IDescriptionsProps {
  size?: 'normal' | 'small'
  columns?: number
  valueWidth?: number | 'fill' | 'fluid'
  valueAlign?: 'left' | 'right'
  wrapLabelText?: boolean
}

export const Descriptions = ({
  size = 'normal',
  columns = 1,
  valueWidth = 'fluid',
  valueAlign = 'left',
  wrapLabelText = true,
  children,
}: PropsWithChildren<IDescriptionsProps>) => {
  return (
    <DescriptionsStyled
      size={size}
      columns={columns}
      valueWidth={valueWidth}
      valueAlign={valueAlign}
      wrapLabelText={wrapLabelText}
    >
      {children}
    </DescriptionsStyled>
  )
}

Descriptions.Item = DescriptionItem

Descriptions.displayName = 'Descriptions'
